var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white text-black exam-evaluation-container p-3" },
    [
      _c(
        "div",
        { class: "d-flex " + (_vm.mobile ? "flex-column" : "") },
        [
          _vm.examEvaluation.value
            ? _c(
                "div",
                {
                  staticClass: "evaluation-value",
                  style: {
                    fontSize:
                      _vm.examEvaluation.kind == "normal" ? "3rem" : "1.5rem",
                  },
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(_vm.examEvaluation.value) + "\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("v-spacer", { class: "" + (_vm.mobile ? "my-3" : "mx-3") }),
          _vm._v(" "),
          _c("div", {
            staticClass: "evaluation-description font-weight-bold py-2",
            domProps: { innerHTML: _vm._s(_vm.examEvaluation.description) },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-divider", { class: "mt-0 " + (_vm.mobile ? "mb-6" : "") }),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.examEvaluation.body) } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }